import { HttpClinet, baseURL, version } from './../utils/config'

export const notificationAPI = {
    getNotification: (page) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/notification/getNotification?page=${page}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    },
    readNotification: (_id) => {
        return HttpClinet({
            url: `${baseURL}/api/${version}/notification/readNotification`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { _id }
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                // console.log(error+' ไอปั้นปิด Services')
                throw error
            })
    }
}